'use strict'
import {cl} from "./common";

const click_attribute = "data-dropdown-clicked";

document.addEventListener("DOMContentLoaded", function (){
	cl('Dropdown Menu init');
	document.querySelectorAll("a.nav-link.dropdown-toggle[href]").forEach( e => {
		e.addEventListener('click', dropdown_clicked);
	})
})

function dropdown_clicked(ev){
	this.setAttribute(click_attribute, true);
	document.addEventListener('click', document_clicked.bind(this), {once: true, capture: true});
}

function document_clicked(ev){
	if(this.hasAttribute(click_attribute) && this == ev.target){
		const href = this.getAttribute("href");
		ev.stopPropagation();
		if(window.location != href){
			window.location = href;
		}
	}
	this.removeAttribute(click_attribute);
}
